import { allFlagsOff, FeatureFlagKey } from '@/services/flags/featureFlagDefinitions';
import { trpc } from '@/utils/trpc';

// Resolved flags for the signed-in user. Realtime keeps this fresh: the
// `feature_flag` broadcast handler invalidates the query when a flag is
// toggled (see broadcastHandlers.ts). Falls back to all-off while loading or
// on error so callers can treat the result as always-defined.
export function useFeatureFlags(enabled = true): {
  flags: Record<FeatureFlagKey, boolean>;
  isLoading: boolean;
} {
  const {
    data,
    isLoading
  } = trpc.featureFlag.getMyFlags.useQuery(undefined, {
    enabled,
    staleTime: 60_000
  });
  return {
    flags: data ?? allFlagsOff(),
    isLoading
  };
}
export function useFeatureFlag(key, t0) {
  const enabled = t0 === undefined ? true : t0;
  const {
    flags
  } = useFeatureFlags(enabled);
  return flags[key];
}